import { ApiResponse } from '../api'
import { axios } from '@src/lib/axios'

export type Category = 'car-brand'|'car-model'|'sfx'|'pio'|'car-part'|'factory'|'station'|'shift'

export interface CarBrandDto {
  /** ID */
  uuid?: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description?: string;
  /** 新增時間 */
  createdAt?: string;
}

export interface CarModelDto {
  /** ID */
  uuid?: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description?: string;
  /** 品牌Uuid */
  carBrandUuid: string;
  /** 品牌代碼 */
  carBrandCode?: string;
  /** 品牌描述 */
  carBrandDescription?: string;
  /** 需紀錄QRCode */
  isQRCodeRequired: boolean;
  /** 車種年式 */
  modelYear: string;
  /** 新增時間 */
  createdAt?: string;
}

export interface SfxDto {
  /** ID */
  uuid: string;
  /** 狀態 */
  status: string;
  /** SFX NO */
  sfxNo: string;
  /** 品牌 */
  carBrand: string;
  /** 車種 */
  carModel: string;
  /** 年式 */
  carModelYear: string;
  /** 描述 */
  description: string;
  /** 修改時間 */
  updatedAt: string;
}

export interface PioItemDto {
  /** ID */
  uuid: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 新增時間 */
  createdAt: string;
}

export interface CarPartDto {
  /** ID */
  uuid: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 新增時間 */
  createdAt: string;
}

export interface FactoryDto {
  /** ID */
  uuid?: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 新增時間 */
  createdAt?: string;
}

export interface StationDto {
  /** ID */
  uuid?: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 廠區 */
  factoryUuid: string;
  /** 新增時間 */
  createdAt?: string;
}

export interface ShiftDto {
  /** ID */
  uuid?: string;
  /** 狀態 */
  status: string;
  /** 代碼 */
  code: string;
  /** 描述 */
  description: string;
  /** 廠區 */
  factoryUuid: string;
  /** 新增時間 */
  createdAt?: string;
}

export type ListDataDto = CarBrandDto[] | CarModelDto[] | SfxDto[] | PioItemDto[] | CarPartDto[] | FactoryDto[] | StationDto[] | ShiftDto[]

export type DataDto = CarBrandDto | CarModelDto | SfxDto | PioItemDto | CarPartDto | FactoryDto | StationDto | ShiftDto

export interface GetItemListByCategoryReqDto {
  category: Category;
  keyword: string;
  page: number;
}

export interface GetItemListByCategoryRespDto {
  totalNumber: number;
  data: ListDataDto;
  totalPages: number;
}

/** 取得設定項目清單 */
export async function getItemListByCategory(reqDto: GetItemListByCategoryReqDto): Promise<GetItemListByCategoryRespDto> {
  const { category, page, keyword } = reqDto
  const defaultApiPath = `/api/web/setting/${category}?page=${page}`
  const apiPath = keyword ? `${defaultApiPath}&keyword=${keyword}` : defaultApiPath
  const response = await axios.get<ApiResponse<GetItemListByCategoryRespDto>>(apiPath)

  return response.data
}

export interface AddItemByCategoryReqDto {
  category: Category;
  data: DataDto;
}

/** 新增設定項目 */
export async function addItemByCategory(reqDto: AddItemByCategoryReqDto) {
  const { category, data } = reqDto

  await axios.post<ApiResponse<void>>(`/api/web/setting/${category}`, data)
}

export interface GetItemByCategoryReqDto {
  category: Category;
  uuid: string;
}

export type GetItemByCategoryRespDto = DataDto;

/** 取得設定項目 */
export async function getItemByCategroy(reqDto: GetItemByCategoryReqDto): Promise<GetItemByCategoryRespDto> {
  const { category, uuid } = reqDto

  const response = await axios.get<ApiResponse<GetItemByCategoryRespDto>>(`/api/web/setting/${category}/${uuid}`)

  return response.data
}

export interface DeleteItemByCategoryReqDto {
  category: Category;
  uuid: string;
}

/** 刪除設定項目 */
export async function deleteItemByCategroy(reqDto: DeleteItemByCategoryReqDto) {
  const { category, uuid } = reqDto

  await axios.delete<ApiResponse<void>>(`/api/web/setting/${category}/${uuid}`)

}

export interface UpdateItemByCategoryReqDto {
  category: Category;
  uuid: string;
  data: DataDto;
}

/** 更新設定項目 */
export async function updateItemByCategroy(reqDto: UpdateItemByCategoryReqDto) {
  const { category, uuid, data } = reqDto

  await axios.put<ApiResponse<void>>(`/api/web/setting/${category}/${uuid}`, data)

}
